<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">락커내역</span>
            <span class="txt">
                회원에게 락커를 대여하고, 회수할 수 있습니다. 또한 대여중인 락커의 이용기간을 변경하여 등록할 수
                있습니다. 락커자체의 기본설정 (락커의 이름과
                <br />
                금액 책정방식)을 변경하시려면
                <span class="blue">설정 &gt; 센터설정 &gt; 락커</span>
                메뉴를 이용해주세요.
            </span>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <!-- 신규 대여내역 -->
            <div v-if="isRegist === true" class="locker-view-content top-info">
                <ul>
                    <li>
                        <span class="num">{{ lockerDetail.lockerNo }}</span>
                        <span class="select-txt">선택가능</span>
                    </li>
                </ul>
                <button class="send-btn" @click="onClickLockerHistory">대여내역</button>
            </div>
            <!-- //신규 대여내역 -->

            <!-- 사용중 대여내역 -->
            <div v-if="isModify === true" class="locker-view-content top-info">
                <ul>
                    <li>
                        <span class="num">{{ lockerDetail.lockerNo }}</span>
                        <div class="btn-cnt">
                            <button class="msg"><span class="blind">문자보내기</span></button>
                            <button
                                class="change"
                                @click="onClickLockerMove(lockerDetail.centerId, lockerDetail.lockerNo)"
                            >
                                <span class="blind">옮기기</span>
                            </button>
                            <button
                                class="del"
                                @click="onClickBtnShowReturnDlg(lockerDetail.centerId, lockerDetail.lockerNo)"
                            >
                                <span class="blind">삭제하기</span>
                            </button>
                        </div>
                        <div class="info">
                            <span class="name">{{ lockerDetail.rentCustomerName }}</span>
                            <div class="line">
                                <span :class="{ icon: true, red: lockerDetail.lockerStatus === 'E' }">사용중</span>
                                <span
                                    :class="{
                                        expire: true,
                                        blue: calcRemainDays(lockerDetail.rentEndedAt) < 0,
                                        red: calcRemainDays(lockerDetail.rentEndedAt) > 0,
                                    }"
                                >
                                    만료{{ calcRemainDays(lockerDetail.rentEndedAt) }}
                                </span>
                                <span :class="`day ${lockerDetail.lockerStatus === 'U' ? 'blue' : 'red'}`">
                                    {{ lockerDetail.rentStartedAt }} ~ {{ lockerDetail.rentEndedAt }}
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
                <button class="send-btn" @click="onClickLockerHistory">대여내역</button>
            </div>
            <!-- //사용중 대여내역 -->

            <p class="sub-title">락커정보</p>

            <div class="com-table-wrap">
                <span class="top-title"><span class="title">대여정보</span></span>

                <div class="com-card-form">
                    <div class="top-area">
                        <div class="line">
                            <span class="top-txt">센터</span>
                            <div class="input-line">
                                <select-form
                                    :disabled="true"
                                    :select-data="['선택', ...chainCenterType]"
                                    :select-value="['', ...chainCenterTypeValue]"
                                    :selected-value="selectedCenterId"
                                    class="w640"
                                    @update:set="(val) => (selectedCenterId = val)"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">락커구분</span>
                            <div class="input-line">
                                <select-form
                                    :disabled="true"
                                    :select-data="[lockerDetail.lockerGroupName]"
                                    class="w640"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">성별</span>
                            <div class="input-line flex">
                                <div class="com-radio">
                                    <input
                                        id="radio-top-1"
                                        v-model="lockerDetail.sex"
                                        disabled
                                        name="radio-top"
                                        type="radio"
                                        value="-"
                                    />
                                    <label for="radio-top-1">공통</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-top-2"
                                        v-model="lockerDetail.sex"
                                        disabled
                                        name="radio-top"
                                        type="radio"
                                        value="M"
                                    />
                                    <label for="radio-top-2">남자</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-top-3"
                                        v-model="lockerDetail.sex"
                                        disabled
                                        name="radio-top"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-top-3">여자</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">락커번호</span>
                            <div class="input-line">
                                <input v-model="lockerDetail.lockerNo" class="w80 center" disabled type="text" />
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">비밀번호</span>
                            <div class="input-line flex">
                                <input v-model="lockerDetail.pw" class="w80 center" type="text" />
                                <button class="com-btn blue" @click="onClickUpdateLockerPasswd">업데이트</button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">회원명</span>
                            <div class="input-line">
                                <input
                                    v-model="editField.name"
                                    class="w285"
                                    disabled
                                    placeholder="이름, 연락처 입력"
                                    type="text"
                                />
                                <button :disabled="isModify === true" class="com-btn" @click="onClickSearchCustomer">
                                    검색
                                </button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">금액</span>
                            <span v-if="isModify && !$route.query.add">
                                {{ `${lockerDetail.rentMonth}개월 - ${getNumberFormat(lockerDetail.rentBillPrice)}원` }}
                            </span>
                            <div class="input-line">
                                <select-form
                                    v-if="$route.query.add"
                                    :select-data="selectFormLockerPrice.data"
                                    :select-value="selectFormLockerPrice.value"
                                    class="w640"
                                    @update:set="updateLockerPrice"
                                />
                                <select-form
                                    v-else
                                    :select-data="selectFormLockerPrice.data"
                                    :select-value="selectFormLockerPrice.value"
                                    :selected-value="selectFormLockerPrice.selectedValue"
                                    class="w640"
                                    @update:set="updateLockerPrice"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="top-txt">기간</span>
                            <div class="input-line">
                                <div class="com-calendar-wrap">
                                    <single-calendar
                                        :start-date="editField.rentStartedAt"
                                        @update="startDateUpdate"
                                    />
                                    <div class="com-dash"><span class="dash">~</span></div>
                                    <single-calendar
                                        :start-date="editField.rentEndedAt"
                                        @update="endDateUpdate"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="middle-area">
                        <!-- 결제 정보 -->
                        <template v-for="(b, index) in editField.bills">
                            <template v-if="isRegist === true">
                                <!-- 등록일 때 -->
                                <payment-info
                                    :key="index"
                                    :bill-data="b"
                                    :index="index"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :mileage="customerInfo.mileage"
                                    :mode="''"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                            </template>

                            <template v-if="isRegist === false">
                                <!-- 수정일 때 -->
                                <payment-info
                                    :key="index"
                                    :bill-data="b"
                                    :index="index"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :mileage="customerInfo.mileage"
                                    :mode="''"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                            </template>
                            <!-- 수정인데 결제정보추가할 경우 -->
                            <template v-if="isRegist === false && !b.hasOwnProperty('mode')">
                                <payment-info
                                    :key="index"
                                    :bill-data="b"
                                    :index="index"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :max="[{ productBuyPrice: b.billPrice }]"
                                    :mileage="customerInfo.mileage"
                                    :mode="''"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                            </template>
                        </template>

                        <!--
            <div class="com-send-btn">
                <button class="com-btn blue" @click="onClickAddPayment">결제정보추가</button>
            </div>
            <div class="bottom-total">
                <span class="tit">결제 후 미수금액 : </span>
                <span class="num">{{ totalDebtPrice }} 원</span>
            </div>
            -->
                    </div>
                </div>
            </div>
            <div class="bottom-btn">
                <button class="com-btn" @click="onClickCancleLockerEdit">취소</button>
                <button v-if="isRegist === true" class="com-btn blue" @click="onClickRegistContract">결제</button>
                <button v-else-if="isModify === true" class="com-btn blue" @click="onClickModifyContract">수정</button>
            </div>

            <!-- 회원 검색 결과 팝업 -->
            <div v-if="userPop" class="layer-pop square-type">
                <div class="view-content">
                    <div class="scroll-area com-scroll-y">
                        <span class="sub-title">회원 검색 결과</span>
                        <div class="top-search-area">
                            <div class="right">
                                <input
                                    ref="refCustomerName"
                                    v-model="searchCustomerStr"
                                    class="w220"
                                    placeholder="회원명"
                                    type="text"
                                    v-on:keyup.enter="onSearchCustomer"
                                />
                                <button class="com-btn" @click="onSearchCustomer">검색</button>
                            </div>
                        </div>
                        <loading-spinner v-if="customerIsLoading"></loading-spinner>
                        <table v-else class="com-table">
                            <colgroup>
                                <col style="width: 70px" />
                                <col style="width: 120px" />
                                <col style="width: 120px" />
                                <col style="width: 160px" />
                                <col style="width: 160px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>회원명</th>
                                    <th>닉네임</th>
                                    <th>연락처</th>
                                    <th>생년월일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, index) in searchCustomerList" :key="index">
                                    <td>
                                        <div class="com-radio">
                                            <input
                                                :id="`radio-pop-${index + 1}`"
                                                v-model="pickedCustomerId"
                                                :value="c.center_cust_id"
                                                name="radio-pop"
                                                type="radio"
                                            />
                                            <label :for="`radio-pop-${index + 1}`"></label>
                                        </div>
                                    </td>
                                    <td>{{ c.namee }}</td>
                                    <td>{{ c.nick_name }}</td>
                                    <td>{{ c.phone | customerPhoneFilter }}</td>
                                    <td>{{ c.birthday | dateFormatFilter }}</td>
                                </tr>
                                <tr v-if="searchCustomerList.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>

                        <b-pagination
                            v-if="pagingInfo.totalItems > 0"
                            v-model="pagingInfo.page"
                            :per-page="pagingInfo.limit"
                            :total-rows="pagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event, 'customer')"
                        ></b-pagination>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCancleSearchPop">취소</button>
                            <button class="com-btn blue" @click="onClickPickCustomer">선택</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 대여내역 팝업 -->
            <div v-show="rentPop" class="layer-pop square-type">
                <div class="view-content w1070">
                    <button class="close" @click="rentPop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            대여내역
                            <span class="info-txt">
                                {{ lockerDetail.lockerGroupName }} {{ lockerDetail.lockerNo }}번
                            </span>
                        </span>
                        <loading-spinner v-if="lockerHistoryIsLoading"></loading-spinner>
                        <table v-else class="com-table">
                            <colgroup>
                                <col style="width: 120px" />
                                <!--                                <col style="width: 180px;">-->
                                <!--                                <col style="width: 225px;">-->
                                <col style="width: 270px" />
                                <col style="width: 180px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>회원명</th>
                                    <!--                                    <th>결제일자</th>-->
                                    <!--                                    <th>결제정보</th>-->
                                    <th>유효기간</th>
                                    <th>회수일자</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(h, index) in lockerHistory" :key="index">
                                    <td>{{ h.clh_rent_cust_nm }}</td>
                                    <!--                                    <td>{{ h.createDate | timestampFilter }}</td>-->
                                    <!--                                    <td>{{ h.period }}개월 {{ h.price | numberFormatFilter }}원</td>-->
                                    <td>
                                        {{ h.clh_rent_start_dt | timestampFilter }} ~
                                        {{ h.clh_rent_end_dt | timestampFilter }}
                                    </td>
                                    <td>
                                        <button
                                            v-if="!h.clh_rent_return_dt"
                                            class="com-btn"
                                            @click="onClickBtnCloseAndShowReturnDlg"
                                        >
                                            회수
                                        </button>
                                        <span v-else>{{ h.clh_rent_return_dt | timestampFilter }}</span>
                                    </td>
                                </tr>
                                <!--                                <tr>-->
                                <!--                                    <td>홍길동</td>-->
                                <!--                                    <td>2019-12-23</td>-->
                                <!--                                    <td>1개월 15,000원</td>-->
                                <!--                                    <td>2019-12-25 ~ 2020-01-24</td>-->
                                <!--                                    <td>2019-12-23</td>-->
                                <!--                                </tr>-->
                                <tr v-if="lockerHistory.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-pagination
                            v-model="lockerHistoryPagingInfo.page"
                            :per-page="lockerHistoryPagingInfo.limit"
                            :total-rows="lockerHistoryPagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event, 'lockerHistory')"
                        ></b-pagination>
                    </div>
                </div>
            </div>

            <!-- 락커이동 팝업 -->
            <div v-if="lockerMovePop && lockerDetail" class="layer-pop square-type">
                <div class="view-content w655">
                    <button class="close" @click="onClickCloseLockerMovePop">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <loading-spinner v-if="lockerMovePopIsLoading"></loading-spinner>
                    <div v-else class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            락커이동
                            <span class="info-txt">{{ lockerDetail.lockerNo }}번</span>
                        </span>
                        <p class="sub-txt">사용 중인 락커를 이동 하시겠습니까?</p>
                        <table class="com-table left no-border">
                            <colgroup>
                                <col style="width: 135px" />
                                <col style="width: 465px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>센터</th>
                                    <td>{{ lockerDetail.centerId }}</td>
                                </tr>
                                <tr>
                                    <th>락커구분</th>
                                    <td>{{ lockerDetail.lockerGroupName }}</td>
                                </tr>
                                <tr>
                                    <th>성별</th>
                                    <td>
                                        <div class="flex">
                                            {{ convertLockerSex(lockerDetail.sex) }}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>락커번호</th>
                                    <td>
                                        <select-form
                                            :select-data="['선택', ...emptyLockerNoList]"
                                            :select-value="['', ...emptyLockerNoValueList]"
                                            class="w265"
                                            @update:set="(val) => (lockerDetail.newLockerNo = val)"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ lockerDetail.rentCustomerName }}</td>
                                </tr>
                                <tr>
                                    <th>기간</th>
                                    <td>{{ lockerDetail.rentStartedAt }} ~ {{ lockerDetail.rentEndedAt }}</td>
                                </tr>
                                <tr>
                                    <th>금액</th>
                                    <td>
                                        {{ lockerDetail.rentMonth }}개월 -
                                        {{ lockerDetail.rentBillPrice | numberFormatFilter }}원
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCloseLockerMovePop">취소</button>
                            <button class="com-btn blue" @click="onClickLockerMoveSave">이동</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 락커회수 삭제 팝업 -->
            <div v-if="lockerDelPop && lockerDetail" class="layer-pop square-type">
                <div class="view-content w655">
                    <button class="close" @click="onClickCloseLockerDelPop">
                        <span class="blind">팝업 닫기</span>
                    </button>
                    <loading-spinner v-if="lockerDelPopIsLoading"></loading-spinner>
                    <div v-else class="scroll-area com-scroll-y">
                        <span class="sub-title">
                            락커회수
                            <span class="info-txt">{{ lockerDetail.lockerNo }}번</span>
                        </span>
                        <p class="sub-txt">사용 중인 락커를 삭제 하시겠습니까?</p>
                        <table class="com-table left no-border">
                            <colgroup>
                                <col style="width: 135px" />
                                <col style="width: 465px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>센터</th>
                                    <td>{{ lockerDetail.centerId }}</td>
                                </tr>
                                <tr>
                                    <th>락커구분</th>
                                    <td>{{ lockerDetail.lockerGroupName }}</td>
                                </tr>
                                <tr>
                                    <th>성별</th>
                                    <td>{{ convertLockerSex(lockerDetail.sex) }}</td>
                                </tr>
                                <tr>
                                    <th>락커번호</th>
                                    <td>
                                        <!--                                        <select-form :select-data="['선택', ...emptyLockerNoList]" :select-value="['', ...emptyLockerNoValueList]" class="w265" @update:set="val => lockerDetail.newLockerNo = val"></select-form>-->
                                        {{ lockerDetail.lockerNo }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>회원명</th>
                                    <td>{{ lockerDetail.rentCustomerName }}</td>
                                </tr>
                                <tr>
                                    <th>대여기간</th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :start-date="lockerDetail.rentStartedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="lockerDetail.rentEndedAt"
                                                class="w150"
                                                disabled
                                            ></single-calendar>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>금액</th>
                                    <td>
                                        {{ lockerDetail.rentMonth }}개월 -
                                        {{ lockerDetail.rentBillPrice | numberFormatFilter }}원
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="red">회수날짜</span></th>
                                    <td>
                                        <single-calendar
                                            :date="this.today"
                                            :disabled="true"
                                            class="w150"
                                        ></single-calendar>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCloseLockerDelPop">취소</button>
                            <button class="com-btn blue" @click="onClickLockerExtend">연장</button>
                            <button class="com-btn blue" @click="onClickBtnLockerReturn">회수</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import moment from 'moment';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'MemberLockerEdit',
    components: { LoadingSpinner },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return parseInt(getters['auth/staffId']);
        },
        isRegist() {
            // 락커 등록일 때
            // return (this.lockerDetail.lockerStatus === '-' || this.lockerDetail.lockerStatus === 'R') ? true : false;
            return Utils.isEmpty(this.lockerDetail.centerContractId);
        },
        isModify() {
            // 락커 수정일 때
            // return (this.lockerDetail.lockerStatus === 'U' || this.lockerDetail.lockerStatus === 'E') ? true : false;
            return !Utils.isEmpty(this.lockerDetail.centerContractId); // lockerDetail에 결제정보가 있으면 수정
        },
        totalOrgPrice() {
            // 정상가 합계
            // return this.getNumberFormat(this.lockerProductDetail.lockerFixPrice);
            return this.getNumberFormat(this.selectFormLockerPrice.selectedValue);
        },
        totalBuyPrice() {
            // 실제구매가 합계
            // return this.getNumberFormat(this.lockerProductDetail.lockerFixPrice);
            return this.getNumberFormat(this.selectFormLockerPrice.selectedValue);
        },
        totalBillPrice() {
            // 결제 금액 합계
            let billPrice = 0;
            this.editField.bills.forEach((b) => {
                billPrice += parseInt(b.billPrice);
            });
            return billPrice;
        },
        totalDebtPrice() {
            // 미수 금액 합계
            let debtPrice = 0;
            debtPrice = this.getPureNumber(this.totalBuyPrice) - this.getPureNumber(this.totalBillPrice);
            return this.getNumberFormat(debtPrice);
        },
        today() {
            return moment().format('YYYY-MM-DD');
        },
    },
    data() {
        return {
            count: 0,
            userPop: false,
            rentPop: false,
            lockerMovePop: false,
            lockerDelPop: false,

            isLoading: false,
            customerIsLoading: false,
            lockerMovePopIsLoading: false,
            lockerDelPopIsLoading: false,
            lockerHistoryIsLoading: false,
            selectedCenterId: '', // 선택된 centerId
            customerInfo: {},

            chainCenterType: [],
            chainCenterTypeValue: [],

            lockerDetail: {},
            editField: {
                name: '',
                bills: [],
                rentStartedAt: null,
                rentEndedAt: null,
            },

            emptyLockerNoList: [], // 비어 있는 락커 번호 목록
            emptyLockerNoValueList: [], // 비어 있는 락커 번호 목록

            lockerNo: this.$route.params.lockerNo,
            pw: '',
            customerId: this.$route.query.customerId,
            centerProductId: this.$route.query.productId,

            searchCustomerStr: '', // 회원 검색 키워드
            searchCustomerList: [],
            pickedCustomerId: '', // 선택한 회원의 customerId
            pagingInfo: { ...pagingInfo },
            lockerHistoryPagingInfo: { ...pagingInfo },

            lockerHistory: [], // 락커 결제내역 히스토리
            lockerGroupDetailList: [], // 락커 이동시 비어 있는 락커를 찾기 위해 그룹에 속해있는 모든 락커를 넣는 변수
            lockerGroupDetailPagingInfo: {
                page: 1,
                limit: 9999,
            },
            lockerProductDetail: {}, // 락커 이용권 정보
            lockerContractDetail: {}, // 락커 계약 정보
            selectFormLockerPrice: {
                data: [],
                value: [],
                selectedValue: 0,
            },
            rentMonth: 1,
            initRentDateString: '',
        };
    },
    async mounted() {
        this.selectedCenterId = parseInt(this.cId, 10);
        await this.init();
        if (this.$route.query.add) {    // 락커 연장
            this.initRentDateString = this.lockerDetail.rentEndedAt;
            this.editField.bills[0].billDate = moment().format('YYYY-MM-DD');

            this.updateLockerPrice(this.selectFormLockerPrice.value[0], 0);
        }
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 5;
            this.pagingInfo.totalItems = 0;
            await this.fetchChainCenter(); // 소속 체인점 센터 조회
            await this.fetchCenterLockerDetail(this.selectedCenterId, this.centerProductId, this.lockerNo); // 센터 락커 상세 조회
            await this.fetchCenterProdDetail(); // 센터 락커 상품 조회

            if (this.isModify) {
                this.editField.rentStartedAt = this.lockerDetail.rentStartedAt;
                this.editField.rentEndedAt = this.lockerDetail.rentEndedAt;

                // 수정이면 계약을 조회
                await this.fetchCenterContractDetail(); // 센터 회원 계약 조회
            } else {
                this.initRentDate();
                this.addBills();
            }

            if (this.customerId) {
                await this.fetchCustomerDetail(this.customerId); // customerId로 customer 정보 가져오기
            }
            if (!this.isModify) {
                this.editField.bills[0].billPrice = this.selectFormLockerPrice.value[0];
            }

            this.isLoading = false;
        },
        initRentDate() {
            const { lockerDetail, lockerProductDetail, editField } = this;
            editField.rentStartedAt = moment().format('YYYY-MM-DD');
            const period = lockerProductDetail.lockerFixPriceYn ? 1 : lockerProductDetail.lockerMon1Month;
            this.rentMonth = period;
            this.setRentEndedAtWithPeriod(period);
        },
        // 센터 회원 계약 조회
        async fetchCenterContractDetail() {
            try {
                const { data } = await this.sendGetContractDetail();
                this.lockerContractDetail = data;

                this.editField.bills = data.centerContractBills;
                this.editField.bills.forEach((b) => {
                    // 수정일 경우에는 읽기 모드로 고정
                    b.mode = 'read';
                    b.billDate = b.buyDate;
                });

                const { lockerDetail, lockerProductDetail, selectFormLockerPrice } = this;
                if (lockerProductDetail.lockerFixPriceYn) {
                    selectFormLockerPrice.selectedValue = selectFormLockerPrice.value[lockerDetail.rentMonth - 1];
                } else {
                    const len = 5;
                    for (let i = 1; i <= len; i++) {
                        const monthField = `lockerMon${i}Month`;
                        const priceField = `lockerMon${i}Price`;

                        if (
                            !Utils.isEmpty(lockerProductDetail[monthField]) &&
                            lockerProductDetail[monthField] == lockerDetail.rentMonth
                        ) {
                            selectFormLockerPrice.selectedValue = lockerProductDetail[priceField];
                            break;
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 회원 계약 조회 API 호출
        sendGetContractDetail() {
            return api.get(
                `/admin/api/center/${this.selectedCenterId}/customer/${this.customerId}/contract/${this.lockerDetail.centerContractProduct.centerContractId}`
            );
        },

        // 센터 락커 상품 조회
        async fetchCenterProdDetail() {
            try {
                this.emptyLockerNoList = []; // 비어 있는 락커 목록 초기화
                this.emptyLockerNoValueList = []; // 비어 있는 락커 목록 초기화

                const { data } = await this.sendGetProductDetail();
                this.lockerProductDetail = data;
                this.setLockerPrice();

                await this.fetchLockerGroupDetaiAll(this.selectedCenterId, this.centerProductId);

                // const lockerNoEnd = this.lockerProductDetail.lockNumberRangeEnd;
                // for(let no = this.lockerProductDetail.lockNumberRangeStart; no <= lockerNoEnd; no++) {
                //     this.emptyLockerNoList.push(no);
                //     this.emptyLockerNoValueList.push(no);
                // }
            } catch (error) {
                console.log(error);
            }
        },

        async fetchLockerGroupDetaiAll(centerId, centerProductId) {
            try {
                const { data } = await this.sendGetLockerGroupDetailAll(centerId, centerProductId);

                data.forEach((g) => {
                    if (g.locker_status !== 'U') {
                        this.emptyLockerNoList.push(g.locker_no);
                        this.emptyLockerNoValueList.push(g.locker_no);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 락커 그룹 모든 락커 리스트 조회 API 호출
        sendGetLockerGroupDetailAll(centerId, centerProductId) {
            return api.get(`/admin/api/locker/groupDetailAll/${centerId}`, {
                params: {
                    ...this.lockerGroupDetailPagingInfo,
                    searchStr: this.searchStr,
                    centerProductId,
                },
            });
        },

        setLockerPrice() {
            const { selectFormLockerPrice, lockerProductDetail } = this;
            if (lockerProductDetail.lockerFixPriceYn) {
                const len = 12;
                for (let i = 1; i <= len; i++) {
                    const price = lockerProductDetail.lockerFixPrice * i;
                    selectFormLockerPrice.data.push(`${i}개월 - ${this.getNumberFormat(price)}원`);
                    selectFormLockerPrice.value.push(price);
                }
                selectFormLockerPrice.selectedValue = selectFormLockerPrice.value[0];
            } else {
                const len = 5;
                for (let i = 1; i <= len; i++) {
                    const monthField = `lockerMon${i}Month`;
                    const priceField = `lockerMon${i}Price`;

                    if (
                        !Utils.isEmpty(lockerProductDetail[monthField]) &&
                        !Utils.isEmpty(lockerProductDetail[priceField])
                    ) {
                        selectFormLockerPrice.data.push(
                            `${lockerProductDetail[monthField]}개월 - ${this.getNumberFormat(
                                lockerProductDetail[priceField]
                            )}원`
                        );
                        selectFormLockerPrice.value.push(lockerProductDetail[priceField]);
                    }
                }

                if (!Utils.isEmpty(selectFormLockerPrice.value[0])) {
                    selectFormLockerPrice.selectedValue = selectFormLockerPrice.value[0];
                }
            }
        },

        sendGetProductDetail() {
            // 센터상품 조회
            return api.get(`/admin/api/center/${this.selectedCenterId}/product/${this.lockerDetail.centerProductId}`);
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            return api.get(`/admin/api/center/${this.cId}/chain`);
        },

        // 락커 번호로 락커 상세 정보 가져오기
        async fetchCenterLockerDetail(centerId, centerProductId, lockerNo) {
            try {
                const { data } = await this.sendGetCenterLockerDetail(centerId, centerProductId, lockerNo);
                this.lockerDetail = data;
            } catch (error) {
                alert('락커 상세 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 락커 상세정보 조회 API 호출
        sendGetCenterLockerDetail(centerId, centerProductId, lockerNo) {
            return api.get(`/admin/api/locker/detail/${centerId}/${centerProductId}/${lockerNo}`);
        },

        // 회원명 검색 버튼 클릭시
        onClickSearchCustomer() {
            this.userPop = true;
            this.$nextTick(function () {
                this.$refs.refCustomerName.focus();
            });
        },
        async onClickUpdateLockerPasswd() {
            await api.put(
                `/admin/api/locker/detail/${this.cId}/${this.centerProductId}/${this.lockerDetail.lockerNo}?pw=${this.lockerDetail.pw}`
            );
            alert('패스워드를 업데이트 했습니다');
        },

        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                this.customerIsLoading = true;
                const { data } = await this.sendGetCustomer();
                this.setPageParams(data);
                this.searchCustomerList = data.items;
                this.customerIsLoading = false;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.cId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },

        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 회원 검색 팝업 선택 버튼 클릭시
        async onClickPickCustomer() {
            if (this.pickedCustomerId === '') {
                alert('회원을 선택하세요.');
                return;
            }
            await this.fetchCustomerDetail(this.pickedCustomerId); // 선택한 회원 id로 customer 상세 정보 가져옴
            this.customerId = this.pickedCustomerId; // 현재 페이지의 customerId를 넣어줌

            // 회원 검색 관련 변수 초기화
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 페이징 파라미터 저장
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 센터 회원 검색 페이지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'lockerHistory') {
                this.lockerHistoryPagingInfo.page = event;
                this.fetchLockerHistory();
            } else if (pagingType === 'customer') {
                this.pagingInfo.page = event;
                this.onSearchCustomer();
            }
        },

        // 결제정보추가 버튼 클릭시
        onClickAddPayment() {
            this.addBills();
        },

        // 결제정보 추가
        addBills(bill) {
            if (bill === undefined) {
                bill = {
                    billPrice: 0,
                    payType: 'C',
                    payCardType: '',
                    payBankType: '',
                    billDate: this.today,
                };
            }

            this.editField.bills.push(bill);
        },

        // payment-info 변경 감지 이벤트
        onChangePaymentFields(params) {
            const { data, index } = params;
            this.$set(this.editField.bills, index, { ...data });
        },

        // payment-info 삭제 감지 이벤트
        onClickDeletePaymentFields(index) {
            this.$delete(this.editField.bills, index);
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                this.customerInfo = data; // 가져온 그대로 customerInfo에 넣기
                const { editField } = this;

                editField.name = this.customerInfo.name;
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 기본 정보 조회 API 호출
        sendGetCustomerDetail(customerId) {
            return api.get(`/admin/api/center/${this.cId}/customer/${customerId}`);
        },

        // 대여 기간 시작일 변경 event
        startDateUpdate(val) {
            this.editField.rentStartedAt = val;
            // 시작일 변경시 개월수에 맞게 종료일 변경
            this.editField.rentEndedAt = moment(val)
                .add(this.lockerDetail.rentMonth || this.rentMonth, 'months')
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
        },

        // 대여 기간 종료일 변경 event
        endDateUpdate(val) {
            if (val === '' || val === undefined || val === null) {
                return;
            }
            const checkAfterStartDt = moment(val).isSameOrAfter(this.editField.rentStartedAt, 'day'); // 선택된 시작일 이후인지 체크
            if (checkAfterStartDt === false) {
                this.editField.rentEndedAt = '';
                alert('시작일보다 이전 날짜입니다. 다시 선택하세요.');
            } else {
                this.editField.rentEndedAt = val;
                // this.lockerDetail.rentStartedAt = moment(val).subtract(this.lockerDetail.rentMonth, 'months').format('YYYY-MM-DD');
            }
        },

        // 락커 결제 화면 취소버튼 클릭시
        onClickCancleLockerEdit() {
            this.$router.push('/madmin/member/locker');
        },

        // 락커 결제 화면 결제 버튼 클릭시 (신규 대여)
        async onClickRegistContract(add = false) {
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                this.isLoading = true;
                await this.sendPostRegistContract(add);
                alert('락커 결제 되었습니다.');
                this.isLoading = false;
                this.$router.push('/madmin/member/locker');
            } catch (error) {
                this.isLoading = false;
                alert('락커 결제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원계약 등록 API 호출
        sendPostRegistContract(add = false) {
            const params = this.getRegistParams();
            return api.post(
                `/admin/api/center/${this.customerInfo.centerId}/customer/${this.customerInfo.centerCustomerId}/contract`,
                {
                    ...params,
                    add,
                }
            );
        },

        // 센터회원계약 등록 파라미터 가공
        getRegistParams() {
            const { editField, lockerDetail, lockerProductDetail } = this;

            const bills = [];
            let totalSpendMileage = 0; // 마일리지 사용 금액 총합
            let totalEtcPrice = 0; // 기타 할인 금액 총합
            editField.bills.forEach((b, index) => {
                // 결제 정보 가공
                const temp = {
                    debtYn: 'N',
                    billSeq: index,
                    buyDate: b.billDate, // 결제 일자
                    billPrice: this.getPureNumber(b.billPrice), // 결제 금액
                    payType: b.payType, // 결제 수단
                    payCardType: b.payCardType, // 결제 카드 유형
                    payBankType: b.payBankType, // 결제 은행 유형
                    mileage: this.getPureNumber(b.acmltMileagePrice), // 적립 차감 마일리지
                    receiptType: b.receiptType, // 영수증 발행 유형 코드
                    receiptNo: b.receiptNo, // 영수증 발행 번호
                };
                if (b.payType === 'M') {
                    // 결제수단이 마일리지일 때 마일리지 사용 금액 총합에 더해줌
                    totalSpendMileage += b.spendMileage;
                }
                if (b.payType === 'E') {
                    // 결제수단이 기타일 때 기타 결제 금액을 총합에 더해줌
                    totalEtcPrice += b.billPrice;
                }
                if (b.payType !== 'L' && b.payType !== 'B') {
                    // 현금, 계좌이체가 아닐때 영수증 관련 파라미터는 삭제
                    delete temp.receiptType;
                    delete temp.receiptNo;
                }
                if (b.payType !== 'C') {
                    // 카드가 아닐때 카드 파라미터 삭제
                    delete temp.payCardType;
                }
                if (b.payType !== 'B') {
                    // 계좌이체가 아닐때 은행 파라미터 삭제
                    delete temp.payBankType;
                }
                bills.push(temp);
            });

            const pureOrgPrice = this.getPureNumber(this.totalOrgPrice);
            const pureBuyPrice = this.getPureNumber(this.totalBuyPrice);

            const products = [
                {
                    centerProductId: this.getPureNumber(lockerDetail.centerProductId),
                    centerProductVersion: this.getPureNumber(lockerProductDetail.centerProductVersion),
                    productOrgPrice: pureOrgPrice,
                    productBuyPrice: pureBuyPrice,
                    expireStartDt: this.editField.rentStartedAt,
                    expireEndDt: this.editField.rentEndedAt,
                },
            ];

            const params = {
                contractType: 'N', // 계약 유형 코드 (신규계약 : N, 재등록 : R, 환불 : C)
                productType: 'L', // 구매상품 유형 코드 (이용권 : T, 패키지 : P, 락커 : L, 부가상품 : S)
                totalProductCount: 1, // 전체상품갯수
                totalOrgPrice: pureOrgPrice, // 전체정상가격
                totalBuyPrice: pureBuyPrice, // 전체실구매가격
                regStaffId: this.staffId, // 입력자직원아이디
                mileageUsePrice: totalSpendMileage, // 마일리지 사용금액
                etcDiscountPrice: totalEtcPrice, // 기타 할인금액
                retunYn: 'N', // 환불 여부
                centerProductId: this.getPureNumber(lockerDetail.centerProductId), // 센터상품아이디
                centerProductVersion: this.getPureNumber(lockerProductDetail.centerProductVersion), // 센터상품버젼
                totalDebtPrice: 0, // 전체 미수금
                lockerNo: lockerDetail.lockerNo,
                rentStartedAt: moment(this.editField.rentStartedAt).format('YYYYMMDD'),
                rentEndedAt: moment(this.editField.rentEndedAt).format('YYYYMMDD'),
                rentMonth: this.rentMonth,
                products, // 센터회원 계약 상품
                bills, // 센터회원 계약 결제정보
            };

            return params;
        },

        // 결제시 입력값 validate
        validateValues() {
            let result = false;
            let msg = '';
            const { customerId, lockerDetail, editField } = this;

            // 회원명
            if (customerId === undefined || customerId === null) {
                msg = '회원명을 선택하세요.';
                return { result, msg };
            }

            // 기간
            if (editField.rentStartedAt === null || editField.rentEndedAt === null) {
                msg = '기간을 선택하세요.';
                return { result, msg };
            }

            // 결제 후 미수금액 체크
            if (this.getPureNumber(this.totalBuyPrice) - this.getPureNumber(this.totalBillPrice) < 0) {
                // 총 구매 금액 - 총 결제 금액 = 총 미수 금액
                msg = '결제금액이 결제 예정 금액보다 큽니다. 결제 금액을 수정하세요.';
            }
            // 결제정보 은행여부
            if (this.editField.bills[0].payType === 'C' && this.editField.bills[0].payCardType === '') {
                msg = '카드를 선택해주세요.';
                return { result, msg };
            }

            result = true;
            return { result, msg };
        },

        // 락커 결제 화면 수정 버튼 클릭시 (대여중인 락커)
        async onClickModifyContract() {
            if (this.$route.query.add) {    // 연장
                await this.onClickRegistContract(true);
            } else {
                try {
                    this.isLoading = true;
                    await this.sendPutModifyContract();
                    alert('락커 결제 수정 되었습니다.');
                    await this.fetchCenterContractDetail(); // 센터 회원 계약 조회
                    this.isLoading = false;
                } catch (error) {
                    this.isLoading = false;
                    alert('락커 결제 수정 중 오류가 발생했습니다.');
                    console.log(error);
                }
            }
        },

        // 센터회원계약 수정 API 호출
        sendPutModifyContract() {
            const params = this.getModifyParams();
            // 스웨거 검색: 센터회원계약 수정
            return api.put(
                `/admin/api/center/${this.customerInfo.centerId}/customer/${this.customerInfo.centerCustomerId}/contract/${this.lockerDetail.centerContractProduct.centerContractId}`,
                {
                    ...params,
                }
            );
        },

        // 센터회원계약 수정 파라미터 가공
        getModifyParams() {
            const { editField, lockerDetail, lockerProductDetail } = this;
            const { contractProductSeq } = this.lockerContractDetail.centerContractProducts[0];
            const bills = [];
            let totalSpendMileage = 0; // 마일리지 사용 금액 총합
            let totalEtcPrice = 0; // 기타 할인 금액 총합
            editField.bills.forEach((b, index) => {
                // 결제 정보 가공
                const temp = {
                    debtYn: 'N',
                    billSeq: index,
                    buyDate: b.billDate, // 결제 일자
                    billPrice: this.getPureNumber(b.billPrice), // 결제 금액
                    payType: b.payType, // 결제 수단
                    payCardType: b.payCardType, // 결제 카드 유형
                    payBankType: b.payBankType, // 결제 은행 유형
                    mileage: this.getPureNumber(b.acmltMileagePrice), // 적립 차감 마일리지
                    receiptType: b.receiptType, // 영수증 발행 유형 코드
                    receiptNo: b.receiptNo, // 영수증 발행 번호
                };
                if (b.payType === 'M') {
                    // 결제수단이 마일리지일 때 마일리지 사용 금액 총합에 더해줌
                    totalSpendMileage += b.spendMileage;
                }
                if (b.payType === 'E') {
                    // 결제수단이 기타일 때 기타 결제 금액을 총합에 더해줌
                    totalEtcPrice += b.billPrice;
                }
                if (b.payType !== 'L' && b.payType !== 'B') {
                    // 현금, 계좌이체가 아닐때 영수증 관련 파라미터는 삭제
                    delete temp.receiptType;
                    delete temp.receiptNo;
                }
                if (b.payType !== 'C') {
                    // 카드가 아닐때 카드 파라미터 삭제
                    delete temp.payCardType;
                }
                if (b.payType !== 'B') {
                    // 계좌이체가 아닐때 은행 파라미터 삭제
                    delete temp.payBankType;
                }
                bills.push(temp);
            });

            const pureOrgPrice = this.getPureNumber(this.totalOrgPrice);
            const pureBuyPrice = this.getPureNumber(this.totalBuyPrice);

            const products = [];
            // 락커 상품 정보 가공
            const temp = {
                centerProductId: this.getPureNumber(lockerDetail.centerProductId),
                centerProductVersion: this.getPureNumber(lockerProductDetail.centerProductVersion),
                contractProductSeq,
                productOrgPrice: pureOrgPrice,
                productBuyPrice: pureBuyPrice,
                expireStartDt: this.editField.rentStartedAt,
                expireEndDt: this.editField.rentEndedAt,
            };
            products.push(temp);

            const params = {
                contractType: 'N', // 계약 유형 코드 (신규계약 : N, 재등록 : R, 환불 : C)
                productType: 'L', // 구매상품 유형 코드 (이용권 : T, 패키지 : P, 락커 : L, 부가상품 : S)
                totalProductCount: 1, // 전체상품갯수
                totalOrgPrice: pureOrgPrice, // 전체정상가격
                totalBuyPrice: pureBuyPrice, // 전체실구매가격
                regStaffId: this.staffId, // 입력자직원아이디
                mileageUsePrice: totalSpendMileage, // 마일리지 사용금액
                etcDiscountPrice: totalEtcPrice, // 기타 할인금액
                retunYn: 'N', // 환불 여부
                centerProductId: this.getPureNumber(lockerDetail.centerProductId), // 센터상품아이디
                centerProductVersion: this.getPureNumber(lockerProductDetail.centerProductVersion), // 센터상품버젼
                totalDebtPrice: 0, // 전체 미수금
                lockerStatus: lockerDetail.lockerStatus,
                lockerNo: lockerDetail.lockerNo,
                rentStartedAt: moment(this.editField.rentStartedAt).format('YYYYMMDD'),
                rentEndedAt: moment(this.editField.rentEndedAt).format('YYYYMMDD'),
                rentMonth: this.lockerDetail.rentMonth,
                pw: this.lockerDetail.pw,
                products, // 센터회원 계약 상품
                bills, // 센터회원 계약 결제정보
            };

            return params;
        },

        // 금액에 , 넣기
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // 금액에 , 빼기
        getPureNumber(str) {
            if (typeof str !== 'string' || str === undefined || str === '') {
                return str;
            }
            return parseInt(str.toString().replace(/[^\d]+/g, ''));
        },

        // 숫자 이외 입력 방지
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (!(charCode >= 48 && charCode <= 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 락커 이동 버튼 클릭시
        onClickLockerMove(centerId, lockerNo) {
            this.lockerMovePop = true;
            this.fetchCenterLockerDetail(centerId, this.centerProductId, lockerNo);
            // this.fetchLockerGroupDetailList(this.lockerDetail.centerId, this.lockerDetail.centerProductId, this.lockerDetail.centerProductVersion);
        },

        // 락커 이동 팝업 닫기 클릭시
        onClickCloseLockerMovePop() {
            this.lockerMovePop = false;
        },

        // 락커 이동 팝업에서 이동 버튼 클릭시
        async onClickLockerMoveSave() {
            try {
                if (!this.lockerDetail.hasOwnProperty('newLockerNo')) {
                    alert('락커번호를 선택하세요.');
                    return false;
                }
                if (!confirm('락커를 이동하시겠습니까?')) {
                    return false;
                }
                this.lockerMovePopIsLoading = true;
                await this.sendPutLockerMove();
                alert('락커를 이동했습니다.');
                this.lockerMovePopIsLoading = false;
                this.lockerMovePop = false;
                this.$router.push('/madmin/member/locker');
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                this.lockerMovePopIsLoading = false;
            }
        },

        // 락커 이동 API 호출
        sendPutLockerMove() {
            const params = this.getLockerMoveParams();
            return api.put('/admin/api/locker/move', {
                ...params,
            });
        },

        // 락커 이동 파라미터 가공
        getLockerMoveParams() {
            const { lockerDetail } = this;
            const params = {
                centerId: lockerDetail.centerId,
                curLockerNo: lockerDetail.lockerNo,
                centerProductId: lockerDetail.centerProductId,
                newLockerNo: lockerDetail.newLockerNo,
                customerId: lockerDetail.rentCustomerId,
                customerName: lockerDetail.rentCustomerName,
            };
            return params;
        },

        // 락커 만료 일자 계산
        calcRemainDays(endDt) {
            const ed = moment(endDt, 'YYYY-MM-DD');
            const currentDate = moment().startOf('day');
            const remainDays = moment.duration(ed.diff(currentDate)).asDays();
            return remainDays >= 0 ? `-${remainDays}` : String(remainDays).replace('-', '+');
        },

        // 락커 성별 변환
        convertLockerSex(sex) {
            if (sex === '-') {
                return '공통';
            } else if (sex === 'M') {
                return '남성';
            } else if (sex === 'W') {
                return '여성';
            }
        },

        // 락커 휴지통 버튼 클릭시
        onClickBtnShowReturnDlg(centerId, lockerNo) {
            this.fetchCenterLockerDetail(centerId, this.centerProductId, lockerNo);
            this.lockerDelPop = true;
        },

        // 락커 삭제 팝업 닫기 버튼 클릭시
        onClickCloseLockerDelPop() {
            this.lockerDelPop = false;
        },

        /*
    // 락커 그룹 상세 목록 가져오기
    async fetchLockerGroupDetailList(centerId, centerProductId, centerProductVersion) {
        try {
            const { data } = await this.sendGetLockerGroupDetail(centerId, centerProductId, centerProductVersion);
            this.setPageParams(data);
            this.lockerGroupDetailList = data.items;

            console.log('fetchLockerGroupDetailList', data);

        } catch (error) {
            console.log(error);
        }
    },
     */

        // 락커 그룹 상세 조회 API 호출
        sendGetLockerGroupDetail(centerId, centerProductId, centerProductVersion) {
            return api.get(`/admin/api/locker/groupDetail/${centerId}`, {
                params: {
                    ...this.lockerGroupDetailPagingInfo,
                    centerProductId,
                    centerProductVersion,
                },
            });
        },

        onClickBtnCloseAndShowReturnDlg() {
            this.onClickBtnShowReturnDlg(this.lockerDetail.centerId, this.lockerDetail.lockerNo);
            this.rentPop = false;
        },

        // 대여내역의 회수 버튼 클릭시
        async onClickBtnLockerReturn() {
            if (!confirm('락커를 회수 하시겠습니까?')) {
                return false;
            }

            try {
                this.lockerDelPopIsLoading = true;
                await this.sendPutLockerReturn();
                alert('락커를 회수했습니다.');
                this.lockerDelPopIsLoading = false;
                this.lockerDelPop = false;
                this.$router.push('/madmin/member/locker');

                // await this.fetchLockerGroupDetailList(this.lockerDetail.centerId, this.lockerDetail.centerProductId, this.lockerDetail.centerProductVersion);
            } catch (error) {
                alert('락커 회수 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 락커 회수 API 호출
        sendPutLockerReturn() {
            const params = {
                centerId: this.lockerDetail.centerId,
                curLockerNo: this.lockerDetail.lockerNo,
                centerProductId: this.lockerDetail.centerProductId,
                rentReturnedAt: this.today,
            };
            return api.put('/admin/api/locker/return', {
                ...params,
            });
        },

        // 대여내역 버튼 클릭시
        onClickLockerHistory() {
            this.rentPop = true;
            this.fetchLockerHistory();
        },

        // 락커 결제이력 조회
        async fetchLockerHistory() {
            try {
                this.lockerHistoryIsLoading = true;
                const { data } = await this.sendGetLockerHistory();
                this.lockerHistory = data.items;
                this.lockerHistoryIsLoading = false;
            } catch (error) {
                this.lockerHistoryIsLoading = false;
                console.log(error);
            }
        },

        // 센터 특정락커 결제이력 조회(페이징) API 호출
        sendGetLockerHistory() {
            const params = {
                centerId: this.lockerDetail.centerId,
                centerProductId: this.lockerDetail.centerProductId,
                lockerNo: this.lockerDetail.lockerNo,
            };

            // 스웨거 검색: 센터 특정 락커 대여내역 조회(페이징)
            return api.get('/admin/api/locker/lockerRentHistory/all', {
                params: {
                    ...this.lockerHistoryPagingInfo,
                    ...params,
                },
            });
        },

        // 결제정보 삭제 버튼 클릭시 (b.centerCustomerId, b.centerContractId, b.billSeq, index)
        async onClickDeleteBills(customerId, contractId, billSeq, index) {
            try {
                await this.sendDeleteContractBill(customerId, contractId, billSeq, index);
                alert('결제정보가 삭제 되었습니다.');
                await this.init();
            } catch (error) {
                this.isLoading = false;
                alert('결제정보 삭제 중 오류가 발생했습니다.');
            }
        },

        // 센터회원계약 결제내역 삭제 API 호출
        sendDeleteContractBill(customerId, contractId, billSeq, index) {
            return api.delete(
                `/admin/api/center/${this.selectedCenterId}/customer/${customerId}/contract/${contractId}/bill/${billSeq}`
            );
        },

        // 결제정보 수정 버튼 클릭시 (b.centerCustomerId, b.centerContractId, b.billSeq, index)
        onClickModifyBills(customerId, contractId, billSeq, index) {
            this.editField.bills[index].mode = 'modify'; // 읽기모드 -> 수정모드로 변경
        },

        // 결제정보 저장 버튼 클릭시
        async onClickSaveBills(customerId, contractId, billSeq, index) {
            try {
                await this.sendPutContractBill(customerId, contractId, billSeq, index);
                alert('결제정보가 수정 되었습니다.');
                await this.init();
            } catch (error) {
                this.isLoading = false;
                alert('결제정보 수정 중 오류가 발생했습니다.');
            }
        },

        // 센터회원계약 결제내역 수정 API 호출
        sendPutContractBill(customerId, contractId, billSeq, index) {
            const params = this.getParamsModifyContractBill(customerId, contractId, billSeq, index);
            return api.put(
                `/admin/api/center/${this.selectedCenterId}/customer/${customerId}/contract/${contractId}/bill/${billSeq}`,
                {
                    ...params,
                }
            );
        },

        // 센터회원계약 결제내역 수정 파라미터 가공
        getParamsModifyContractBill(customerId, contractId, billSeq, index) {
            const bill = this.editField.bills[index];

            const params = {
                debtYn: false,
                billSeq,
                buyDate: bill.billDate,
                billPrice: bill.billPrice,
                payType: bill.payType,
                payCardType: bill.payCardType,
                payBankType: bill.payBankType,
                mileage: this.getPureNumber(bill.acmltMileagePrice),
                receiptType: bill.receiptType,
                receiptNo: bill.receiptNo,
            };

            if (bill.payBankType !== 'L' && bill.payType !== 'B') {
                delete params.receiptType;
                delete params.receiptNo;
            }
            if (bill.payType !== 'C') {
                // 카드가 아닐때 카드 파라미터 삭제
                delete params.payCardType;
            }
            if (bill.payType !== 'B') {
                // 계좌이체가 아닐때 은행 파라미터 삭제
                delete params.payBankType;
            }

            return params;
        },
        updateLockerPrice(price, index) {
            for (const b of this.editField.bills) {
                b.price = price;
                b.acmltMileagePrice = price;
            }
            const { selectFormLockerPrice, lockerProductDetail } = this;
            let period = 1;
            if (lockerProductDetail.lockerFixPriceYn) {
                period = index + 1;
            } else {
                period = lockerProductDetail[`lockerMon${index + 1}Month`];
            }
            selectFormLockerPrice.selectedValue = price;
            this.rentMonth = period;
            this.lockerDetail.rentMonth = period;
            this.lockerDetail.rentBillPrice = price;

            // 기간 종료일자 변경
            this.setRentEndedAtWithPeriod(period, this.$route.query.add);
        },
        setRentEndedAtWithPeriod(period, add = false) {
            const { lockerDetail, editField } = this;
            if (add) {
                editField.rentStartedAt = moment(lockerDetail.rentEndedAt, 'YYYY-MM-DD')
                    .add(1, 'days')
                    .format('YYYY-MM-DD');
                editField.rentEndedAt = moment(lockerDetail.rentEndedAt, 'YYYY-MM-DD')
                    .add(period, 'months')
                    .format('YYYY-MM-DD');
            } else {
                editField.rentEndedAt = moment(editField.rentStartedAt, 'YYYY-MM-DD')
                    .add(period, 'months')
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                console.log(editField.rentStartedAt, editField.rentEndedAt)
            }
        },
        // 락커 회수 팝업에서 연장 버튼 클릭시
        async onClickLockerExtend() {
            // eslint-disable-next-line no-restricted-globals
            if (!confirm('현재 락커를 회수 후 연장합니다. 연장하시겠습니까?')) {
                return;
            }

            try {
                this.lockerDelPopIsLoading = true;
                await this.sendPutLockerReturn();

                window.location.reload();
            } catch (e) {
                this.lockerDelPopIsLoading = false;
                Utils.alertResponseErrorMessge(e);
            }
        },
    },
};
</script>
<style lang="scss"></style>
